import { createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "nes-container with-title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Whitelist Mints / Creators", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Add", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Remove", -1)
const _hoisted_5 = { class: "nes-field class=mt-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "address" }, "Address:", -1)
const _hoisted_7 = { class: "mt-5" }
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Creator", -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Mint", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "nes-btn is-primary" }, "Update")
], -1)
const _hoisted_13 = { class: "mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateWhitelist && _ctx.updateWhitelist(...args)), ["prevent"]))
    }, [
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          class: "nes-radio",
          value: "add",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.action) = $event))
        }, null, 512), [
          [_vModelRadio, _ctx.action]
        ]),
        _hoisted_3
      ]),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          class: "nes-radio",
          value: "remove",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.action) = $event))
        }, null, 512), [
          [_vModelRadio, _ctx.action]
        ]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "address",
          class: "nes-input",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.address) = $event))
        }, null, 512), [
          [_vModelText, _ctx.address]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            class: "nes-radio",
            value: _ctx.WhitelistType.Creator,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.type) = $event))
          }, null, 8, _hoisted_8), [
            [_vModelRadio, _ctx.type]
          ]),
          _hoisted_9
        ]),
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            class: "nes-radio",
            value: _ctx.WhitelistType.Mint,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.type) = $event))
          }, null, 8, _hoisted_10), [
            [_vModelRadio, _ctx.type]
          ]),
          _hoisted_11
        ])
      ]),
      _hoisted_12
    ], 32),
    _createElementVNode("div", _hoisted_13, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.proofs, (proof) => {
        return (_openBlock(), _createElementBlock("div", {
          key: proof.address
        }, _toDisplayString(proof.account.whitelistedAddress.toBase58()) + " - " + _toDisplayString(_ctx.parseWhitelistType(proof.account.whitelistType)), 1))
      }), 128))
    ])
  ]))
}